import { PageTitle } from "@components/PageTitle/PageTitle";
import { Sections } from "@components/Sections/Sections";
import React from "react";

import ArticleFooter from "./ArticleFooter";
import { ArticleOutputProps, withArticle } from "./withArticle";

const DateLabel = ({ children }: { children: React.ReactNode }) => (
  <p className="py-maxi uppercase opacity-70">{children}</p>
);

export const Article = withArticle(
  ({
    title,
    paths,
    date,
    content,
    next,
    previous,
    shareImage,
    summary,
  }: ArticleOutputProps) => (
    <>
      <PageTitle title={title} background="lightest" paths={paths}>
        {date ? <DateLabel>{date}</DateLabel> : null}
      </PageTitle>
      <Sections page={content} />
      <ArticleFooter
        previous={previous}
        next={next}
        shareImage={{
          src: shareImage?.asset?.url,
          description: summary,
        }}
      />
    </>
  ),
);

export default Article;
